import { Injectable } from '@angular/core';
import { CanActivate, CanActivateChild, Router } from '@angular/router';
import { BreakData } from 'src/app/view/user-context/services/models/break.data';
import { ContextDataService } from 'src/app/view/user-context/services/context.data-service';
import { SnackBarService } from '../services/snackBar.service';
import { LocalizationService } from '../services/localization.service';
import { DirectDbAccessService } from '../services/direct-database-access.service';
import { DatabaseService } from '../services/database.service';

@Injectable({ providedIn: 'root' })
export class AppBreakGuard implements CanActivate, CanActivateChild {
  constructor(
    private ctxDS: ContextDataService,
    private snackBarService: SnackBarService,
    private router: Router,
    private ls: LocalizationService,
    private dbSrv: DatabaseService
  ) {}

  async canActivate(): Promise<boolean> {
    const commonDbRef = DatabaseService.getCommonDbRef(this.dbSrv);
    if (!commonDbRef) return true;
    const breakData = await DirectDbAccessService.onceObject<BreakData>('appBreak/web', commonDbRef);
    const superAdmin = this.ctxDS.isUserSuperAdmin;
    if (breakData?.active && !superAdmin) {
      this.snackBarService.showWarn(this.ls.translate('context.break'), 'OK');
      this.router.navigate(['/signIn']);
      return false;
    } else return true;
  }

  canActivateChild(): Promise<boolean> {
    return this.canActivate();
  }
}
